module.exports = __webpack_public_path__ + "static/img/equ4.8773a018.png";